import { useQueryClient, useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAxios } from './context.mjs';
import { useReferenceSafeObject } from './hooks/useReferenceSafeObject.mjs';
import makeQuery from './utils/makeQuery.mjs';

function useQueryFromRemote(params) {
  const queryClient = useQueryClient();
  const { instances } = useAxios();
  const { key: rawKey, queryFn, options } = makeQuery(params, instances.json);
  const key = useReferenceSafeObject(rawKey);
  const queryResult = useQuery({
    ...options,
    queryKey: key,
    queryFn
  });
  const invalidate = useCallback(
    (invalidateFilters, invalidateOptions) => queryClient.invalidateQueries(
      invalidateFilters ?? { exact: true, queryKey: key },
      invalidateOptions
    ),
    [key, queryClient]
  );
  const setQueryData = useCallback(
    (updater, setQueryDataOptions) => {
      return queryClient.setQueryData(key, updater, setQueryDataOptions);
    },
    [key, queryClient]
  );
  const cancelQuery = useCallback(() => {
    return queryClient.cancelQueries(key, { exact: true });
  }, [key, queryClient]);
  queryResult.invalidate = invalidate;
  queryResult.setQueryData = setQueryData;
  queryResult.cancelQuery = cancelQuery;
  queryResult.key = key;
  return queryResult;
}

export { useQueryFromRemote as default };
//# sourceMappingURL=useQueryFromRemote.mjs.map
